<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item label="状态筛选:">
                <el-select v-model="listQuery.status" style="width:200px" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="上架" value="1"></el-option>
                    <el-option label="下架" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="位置筛选:">
                <el-select v-model="listQuery.show_type" style="width:200px" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="首页" value="1"></el-option>
                    <el-option label="产品主页" value="2"></el-option>
                    <el-option label="商务合作" value="3"></el-option>
                    <el-option label="关于我们" value="4"></el-option>
                    <el-option label="解决方案-企业微信场景" value="5"></el-option>
                    <el-option label="解决方案-销售行为监控" value="6"></el-option>
                    <el-option label="解决方案-客户资源管理" value="7"></el-option>
                    <el-option label="解决方案-客户精准营销" value="8"></el-option>
                    <el-option label="解决方案-私有化" value="9"></el-option>
                    <el-option label="案例主页" value="10"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
                <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="onAddScrollClick">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" size="mini">
            <el-table-column prop="sort" label="序号" width="80" align="center" />
            <el-table-column label="位置" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.show_type | filterType }}</span>
                </template>
            </el-table-column>

            <el-table-column prop="image" label="图片" align="center">
                <template slot-scope="scope">
                    <el-image style="height: 120px;" fit="contain" :src="imgDomain + scope.row.image" :preview-src-list="[imgDomain + scope.row.image]" />
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="上传日期" width="180" align="center" />
            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status === 1 ? '上架' : '下架' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasEdit" type="primary" size="small" @click="handleEditClick(scope.row)">编辑</el-button>
                    <el-button v-if="hasUp && scope.row.status == 1" type="primary" size="small" @click="handleUpClick(scope.row)">下架</el-button>
                    <el-button v-if="hasDown && scope.row.status == 2" type="primary" size="small" @click="handleUpClick(scope.row)">上架</el-button>
                    <el-button v-if="hasDelete" type="danger" size="small" @click="handleDeleteClick(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>
    </div>
</template>
<script>
import { getScrollList, deleteScroll, bannerShowScroll } from '@/api/content';
import Pagination from '@/components/Pagination';
import { imgDomain } from '@/configs/env';
import operations from '../../mixins/operations';

export default {
    components: { Pagination },
    filters: {
        filterType(val) {
            switch (Number(val)) {
                case 1:
                    return "首页";
                    break;
                case 2:
                    return "产品主页";
                    break;
                case 3:
                    return "商务合作";
                    break;
                case 4:
                    return "关于我们";
                    break;
                case 5:
                    return "解决方案-企业微信场景";
                    break;
                case 6:
                    return "解决方案-销售行为监控";
                    break;
                case 7:
                    return "解决方案-客户资源管理";
                    break;
                case 8:
                    return "解决方案-客户精准营销";
                    break;
                case 9:
                    return "解决方案-私有化";
                    break;
                case 10:
                    return "案例主页";
                    break;
            }
        }
    },
    mixins: [operations],
    data() {
        return {
            imgDomain,
            list: [],
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10
            },
            listLoading: false
        };
    },
    computed: {
        hasAdd() {
            return this.operations.includes('新建轮播图');
        },
        hasUp() {
            return this.operations.includes('上架轮播图');
        },

        hasDown() {
            return this.operations.includes('下架轮播图');
        },
        hasEdit() {
            return this.operations.includes('编辑轮播图');
        },
        hasDelete() {
            return this.operations.includes('删除轮播图');
        }
    },
    async mounted() {
        const pageIndex = sessionStorage.getItem("page_index");
        if (Number(pageIndex)) {
            this.listQuery.page_index = Number(pageIndex);
        }
        this.getList();
    },
    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getScrollList(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
            const pageIndex = sessionStorage.getItem("page_index");
            if (Number(pageIndex) && this.total > 0) {
                this.$nextTick(() => {
                    var elPager = document.getElementsByClassName("number");
                    for (let i = 0;i < elPager.length;i++) {
                        if (i == pageIndex - 1) {
                            elPager[i].classList.add("active");
                        } else {
                            elPager[i].classList.remove("active");
                        }
                    }
                })
            }
            sessionStorage.removeItem("page_index")
        },
        onAddScrollClick() {
            this.$router.push({ path: '/add-carousel' });
        },
        handleEditClick(row) {
            sessionStorage.setItem("page_index", this.listQuery.page_index)
            this.$router.push({
                name: '/add-carousel',
                query: { uuid: row.id }
            });
        },

        async handleUpClick(row) {
            const res = await bannerShowScroll(row.id);
            if (res == true) {
                this.$notify.success({ title: '操作成功' });
            }
            this.getList();
        },

        async handleDeleteClick(id) {
            this.$confirm('确认删除此轮播图?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitDeleteClick(id)
            }).catch(() => {

            });
        },

        async submitDeleteClick(id) {
            const res = await deleteScroll(id);
            if (res == true) {
                this.$notify.success({ title: '操作成功' });
                this.getList();
            } else {
                this.$notify.success({ title: '操作失败' });
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .el-form-item{
        margin-right: 30px;
    }
    .add{
        float: right;
        margin-right: 0;
    }

    .el-pager li.active{

    }
</style>
